import { render } from "./Emailtemplates.vue?vue&type=template&id=31edfe02"
import script from "./Emailtemplates.vue?vue&type=script&lang=js"
export * from "./Emailtemplates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__